import type { Metadata } from "@/lib/head";
import { useEffect } from "react";

import LandingView from "@/modules/landing/ui/landing-view";
import { isNativeApp } from "@/lib/native-bridge";
import { navigateTo } from "@/lib/nav/router-ref";
import { useSignedIn } from "@/pages/landing-session";
import { START_PATH } from "@/pages/start/start-target";
import { BRAND_NAME } from "@buildpy/ui/brand-paths";

export const metadata: Metadata = {
  title: { absolute: `흩어진 현장을 한곳에 — 견적서, 계약서, 공사 사진 | ${BRAND_NAME}` },
  description:
    "직원 10명 이하 인테리어 시공사를 위한 현장관리. 문의부터 잔금까지 견적서, 계약서, 공사 사진과 일지를 한 현장에 모으고, 고객에게는 문자 링크로 보냅니다.",
};

// 첫 화면 — 로그인 없이 누구에게나 보이고, 브라우저 세션이 있으면 앱으로 가는 버튼(APP_CTA 「내 현장으로」)을 보인다(세션 갱신은 /app 에서 한다).
const Page = () => {
  const signedIn = useSignedIn();
  // 앱 안(로그아웃 뒤 등)이면 마케팅 화면 대신 앱 첫 화면으로 — 프리렌더·첫 hydrate 는 그대로 두고 붙은 뒤에 옮긴다.
  useEffect(() => {
    if (isNativeApp()) navigateTo(START_PATH, true);
  }, []);
  return <LandingView signedIn={signedIn} />;
};

export default Page;
